import { render, staticRenderFns } from "./FundingRequests.vue?vue&type=template&id=fb37d456&scoped=true&"
import script from "./FundingRequests.vue?vue&type=script&lang=js&"
export * from "./FundingRequests.vue?vue&type=script&lang=js&"
import style0 from "./FundingRequests.vue?vue&type=style&index=0&id=fb37d456&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb37d456",
  null
  
)

export default component.exports